// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-installments__container {
    margin-bottom: 28px;
}

.payment-installments__installment {
    margin-top: 12px;
}

.payment-installments__installment:first-child {
    margin-top: 0;
}

.payment-installments__installment.success {
    background: #F8F9FA;
    border-radius: 8px;
}

.payment-installments__installment.unique-success {
    border: 1px solid #F0F0F0;
    border-radius: 8px;
}

.payment-installments__installment.unique-success .payment-installments__installment-data  {
    border: 0;
}

.payment-installments__installment-title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 10px;
    border-radius: 8px 8px 0 0;
    border: 1px solid #F0F0F0;
}

.payment-installments__installment-title .hubicon-task_alt {
    font-size: 22px;
    margin-right: 4px;
}

.payment-installments__installment-title .baloa-names {
    color: var(--primary-very-dark-color);
}

.payment-installments__installment-title .baloa-table-column.Success {
    color: #0F5132;
    background: #D1E7DD;
    border-radius: 4px;
    padding: 4px;
    width: fit-content;
    margin-left: auto;
}

.payment-installments__installment-title .baloa-table-column.Pending {
    color: #725912;
    background: #FFF3CD;
    border-radius: 4px;
    padding: 4px;
    width: fit-content;
    margin-left: auto;
}

.payment-installments__installment-title .baloa-table-column.Partial_Payment {
    color: #055160;
    background: #CFF4FC;
    border-radius: 4px;
    padding: 4px;
    width: fit-content;
    margin-left: auto;
}

.payment-installments__installment-data {
    padding: 24px;
    border-radius: 0 0 8px 8px;
    border: 1px solid #F0F0F0;
    border-top: 0;
}

.payment-installments__installment-data__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;
}

.payment-installments__installment-data__item:first-child {
    margin-top: 0;
}

.payment-installments__installment-data__item .baloa-table-column {
    color: var(--primary-dark-color);
    font-weight: var(--font-regular);
}

.payment-installments__installment-data__item .baloa-table {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-medium);
}

.payment-installments__installment-data__item .baloa-table.deadline {
    color: #C62828;
}

.payment-installments__installment-data .button.small {
    margin-top: 24px;
    padding: 12px 10px;
    margin-left: auto;
    margin-right: auto;
}

.payment-installments__installment-data a {
    margin-left: auto;
    margin-right: auto;
    width: fit-content;
    display: flex
;
}`, "",{"version":3,"sources":["webpack://./src/app/payments/components/payment-installments-tournaments/PaymentInstallmentsComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;AACA","sourcesContent":[".payment-installments__container {\n    margin-bottom: 28px;\n}\n\n.payment-installments__installment {\n    margin-top: 12px;\n}\n\n.payment-installments__installment:first-child {\n    margin-top: 0;\n}\n\n.payment-installments__installment.success {\n    background: #F8F9FA;\n    border-radius: 8px;\n}\n\n.payment-installments__installment.unique-success {\n    border: 1px solid #F0F0F0;\n    border-radius: 8px;\n}\n\n.payment-installments__installment.unique-success .payment-installments__installment-data  {\n    border: 0;\n}\n\n.payment-installments__installment-title {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 10px;\n    border-radius: 8px 8px 0 0;\n    border: 1px solid #F0F0F0;\n}\n\n.payment-installments__installment-title .hubicon-task_alt {\n    font-size: 22px;\n    margin-right: 4px;\n}\n\n.payment-installments__installment-title .baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n.payment-installments__installment-title .baloa-table-column.Success {\n    color: #0F5132;\n    background: #D1E7DD;\n    border-radius: 4px;\n    padding: 4px;\n    width: fit-content;\n    margin-left: auto;\n}\n\n.payment-installments__installment-title .baloa-table-column.Pending {\n    color: #725912;\n    background: #FFF3CD;\n    border-radius: 4px;\n    padding: 4px;\n    width: fit-content;\n    margin-left: auto;\n}\n\n.payment-installments__installment-title .baloa-table-column.Partial_Payment {\n    color: #055160;\n    background: #CFF4FC;\n    border-radius: 4px;\n    padding: 4px;\n    width: fit-content;\n    margin-left: auto;\n}\n\n.payment-installments__installment-data {\n    padding: 24px;\n    border-radius: 0 0 8px 8px;\n    border: 1px solid #F0F0F0;\n    border-top: 0;\n}\n\n.payment-installments__installment-data__item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 16px;\n}\n\n.payment-installments__installment-data__item:first-child {\n    margin-top: 0;\n}\n\n.payment-installments__installment-data__item .baloa-table-column {\n    color: var(--primary-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.payment-installments__installment-data__item .baloa-table {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-medium);\n}\n\n.payment-installments__installment-data__item .baloa-table.deadline {\n    color: #C62828;\n}\n\n.payment-installments__installment-data .button.small {\n    margin-top: 24px;\n    padding: 12px 10px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.payment-installments__installment-data a {\n    margin-left: auto;\n    margin-right: auto;\n    width: fit-content;\n    display: flex\n;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
